import type {
  RiskObjectMinimal,
  ROBicycleMinimal,
  ROBoatMinimal,
  ROCarMinimal,
  ROFamilyMinimal,
  ROLegalMinimal,
  ROMiscMinimal,
  ROResidenceMinimal,
  ROTrailerMinimal,
  ROTwoWheelerMinimal,
} from './types';

export const isCar = (
  riskObject: RiskObjectMinimal,
): riskObject is ROCarMinimal => riskObject.risk_object_type === 'CAR';

export const isResidence = (
  riskObject: RiskObjectMinimal,
): riskObject is ROResidenceMinimal =>
  riskObject.risk_object_type === 'RESIDENCE';

export const isBicycle = (
  riskObject: RiskObjectMinimal,
): riskObject is ROBicycleMinimal => riskObject.risk_object_type === 'BICYCLE';

export const isBoat = (
  riskObject: RiskObjectMinimal,
): riskObject is ROBoatMinimal => riskObject.risk_object_type === 'BOAT';

export const isFamily = (
  riskObject: RiskObjectMinimal,
): riskObject is ROFamilyMinimal => riskObject.risk_object_type === 'FAMILY';

export const isLegal = (
  riskObject: RiskObjectMinimal,
): riskObject is ROLegalMinimal => riskObject.risk_object_type === 'LEGAL';

export const isMisc = (
  riskObject: RiskObjectMinimal,
): riskObject is ROMiscMinimal =>
  riskObject.risk_object_type === 'MISCELLANEOUS';

export const isTrailer = (
  riskObject: RiskObjectMinimal,
): riskObject is ROTrailerMinimal => riskObject.risk_object_type === 'TRAILER';

export const isTwoWheeler = (
  riskObject: RiskObjectMinimal,
): riskObject is ROTwoWheelerMinimal =>
  riskObject.risk_object_type === 'TWO_WHEELER';
